/**
 * Returns the formatted time in HH:MM:SS from seconds.
 * @param seconds - The number of seconds to convert.
 * @returns A string formatted as "HH:MM:SS".
 */
export function secondsToHourMinuteSecond(seconds: number | string): string {
	const sec = Number(seconds);

	// Handle invalid (NaN) or negative input
	if (isNaN(sec) || sec < 0) return "00:00:00";

	const hours = Math.floor(sec / 3600);
	const minutes = Math.floor((sec % 3600) / 60);
	const remainingSeconds = sec % 60;

	return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
}